<template>
  <search
    :create-route="createRoute"
    :can-create="canCreate"
    :search-route="searchRoute"
    :page-title="pageTitle"
    :search-filter="searchFilter"
    :place-holder="placeHolder"
    :excluded-fields="['status']"
    :model-name="modelName"
    :is-subscribed="isSubscribed"
  >
    <template slot="results" slot-scope="{ items }">
      <ul class="mt-4 bg-white">
        <li
          v-for="(news, index) in items"
          :key="news.id"
          :class="{
            'border-t border-gray-200': index > 0,
          }"
        >
          <a
            :href="
              news.route
            "
            class="block transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
          >
            <div class="flex items-center px-4 py-4 sm:px-6">
              <div class="flex items-center flex-1 min-w-0">
                <div class="flex-1 min-w-0 px-4 md:grid md:grid-cols-3 md:gap-4">
                  <div class="md:col-span-2">
                    <div
                      class="mb-1 font-semibold leading-5 text-blue-900 truncate hover:text-blue-700 visited:text-indigo-800 text-md"
                    >
                    <p v-html="news.headline"></p>
                    </div>
                    <div class="sm:flex">
                      <div
                        class="flex items-center space-x-2 text-sm leading-5 text-gray-500 sm:mt-0"
                      >
                        <span
                          :class="{
                            'inline-flex px-2 text-xs font-semibold leading-5 text-green-800 bg-green-100 rounded-full': news.status == 'Live',
                            'inline-flex px-2 text-xs font-semibold leading-5 text-yellow-800 bg-yellow-100 rounded-full': news.status != 'Live'
                          }">
                          {{ news.status }}
                        </span>
                        <span v-if="news.posted_at">
                          - Posted on {{ news.posted_at }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="hidden md:block">
                    <div>
                      <div
                        v-if="news.categories.length"
                        class="flex items-center text-xs font-medium leading-5 text-gray-900 truncate"
                      >
                        Category:
                        <span
                          v-for="(model) in news.categories"
                          :key="model.relatable_id"
                          class="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-gray-100 text-gray-800"
                        >
                          {{ model.relatable_type }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <svg
                  class="w-5 h-5 text-gray-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </template>
  </search>
</template>

<script>
export default {
   props: {
    createRoute: {
      type: String,
      required: false,
      default: null
    },
    canCreate: {
      type: Boolean,
      default: false,
    },
    pageTitle: {
      type: String,
      required: true,
    },
    searchRoute: {
      type: String,
      required: true,
    },
    searchFilter: {
      type: [Array, Object],
      required: false,
    },
    placeHolder: {
      type: String,
    },
    modelName: {
      type: String,
    },
    isSubscribed: {
      type: Boolean,
      required: false,
    }
  },
};
</script>
